import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
    COURSE_PROGRESS_QUERY,
    CourseProgressResponse,
    CourseProgressResult,
} from './queries/course-progress.query';

@Injectable({ providedIn: 'root' })
export class CourseProgressService {

    constructor(private apollo: Apollo) {}

    getCourseProgress(courseSubscriptionSessionId: number): Observable<CourseProgressResult> {
        return this.apollo
            .query<CourseProgressResponse>({
                query: COURSE_PROGRESS_QUERY,
                variables: { courseSubscriptionSessionId: String(courseSubscriptionSessionId) },
            })
            .pipe(map(({ data }) => data.courseProgress));
    }
}
